import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AiCallAnswerList } from "../../../redux/services/Ai Services/Ai.Services";
import { successToast, errorToast } from "../../../Utils/toast";

function AddAiAnswer() {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const stateData = location.state || {};
    const [question, setQuestion] = useState(stateData.question || "");
    const [leadType, setLeadType] = useState(stateData.lead_type || "");
    const [answer, setAnswer] = useState(stateData.answer || "");
    const [saving, setSaving] = useState(false);

    // Agar state nahi aayi (direct URL), question blank rahega — warning dikha do
    useEffect(() => {
        if (!id) {
            errorToast("Question ID missing");
            navigate(-1);
        }
    }, [id, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!answer.trim()) {
            errorToast("Please enter an answer");
            return;
        }

        try {
            setSaving(true);

            const payload = {
                question_id: id,
                answer: answer.trim(),
            };

            const res = await AiCallAnswerList(payload);

            if (res?.success === false) {
                errorToast(res?.message || "Failed to save answer");
                return;
            }

            successToast(res?.message || "Answer saved successfully");

            // Wapas list pe jao
            navigate(-1);
        } catch (err) {
            console.error("Answer save error:", err);
            errorToast(
                err?.response?.data?.message || "Something went wrong"
            );
        } finally {
            setSaving(false);
        }
    };

    return (
        <div>
         <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
               <div className="title_member">
                 <h4>Add Answer</h4>
                 <nav className="page-breadcrumb">
                   <Link to="/">Home</Link>
                   <span className="mx-2">/</span>
                   {/* <span>Employee</span> */}
                 </nav>
               </div>
               <div className="d-flex flex-wrap gap-2 justify-content-end">
                 <button className="add-btn" onClick={() => navigate(-1)}>
                   Back
                 </button>
               </div>
             </div>

            <div className="main_page">
                <div className="st-wrapper-card p-4">
                    <form onSubmit={handleSubmit}>
                        {/* Question (read-only) */}
                        <div className="mb-3">
                            <label className="form-label fw-semibold">
                                Question
                            </label>
                            <textarea
                                className="form-control"
                                rows={3}
                                value={question}
                                readOnly
                                placeholder="Question"
                            />
                        </div>

                        {/* Lead Type (read-only) */}
                        {leadType && (
                            <div className="mb-3">
                                <label className="form-label fw-semibold">
                                    Lead Type
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={leadType}
                                    readOnly
                                />
                            </div>
                        )}

                        {/* Answer */}
                        <div className="mb-3">
                            <label className="form-label fw-semibold">
                                Answer <span className="text-danger">*</span>
                            </label>
                            <textarea
                                className="form-control"
                                rows={5}
                                value={answer}
                                onChange={(e) => setAnswer(e.target.value)}
                                placeholder="Type your answer here..."
                            />
                        </div>

                        <div className="d-flex gap-2">
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={saving}
                            >
                                {saving ? "Saving..." : "Save Answer"}
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => navigate(-1)}
                                disabled={saving}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddAiAnswer;